// extracted by css-extract-rspack-plugin
export default {"lastEditInfoContainer":"MarkdownLastEditedBy-module__lastEditInfoContainer__TLH5E","editorLogin":"MarkdownLastEditedBy-module__editorLogin__RpLrU"};